import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["icon", "children", "background", "color"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import * as React from 'react';
import cx from 'classnames';
import * as styles from './styles.css';
import { getColorProps, getBackgroundProps } from './helpers';
var DEFAULT_COLOR = 'white_100';
var DEFAULT_BACKGROUND = 'gray60_100';
export var Label = /*#__PURE__*/React.forwardRef(function Label(_ref, ref) {
  var icon = _ref.icon,
    children = _ref.children,
    background = _ref.background,
    color = _ref.color,
    htmlProps = _objectWithoutProperties(_ref, _excluded);
  var isPointer = !!htmlProps.onClick;
  var colorProps = getColorProps(color || DEFAULT_COLOR);
  var backgroundProps = getBackgroundProps(background || DEFAULT_BACKGROUND);
  return /*#__PURE__*/React.createElement("span", _extends({}, htmlProps, {
    ref: ref,
    className: cx(styles['label'], isPointer && styles['cursor_pointer'], colorProps.className, backgroundProps.className),
    style: _objectSpread(_objectSpread({}, colorProps.style), backgroundProps.style)
  }), icon, children && /*#__PURE__*/React.createElement("span", null, children));
});
Label.defaultProps = {
  color: DEFAULT_COLOR,
  background: DEFAULT_BACKGROUND
};